import { ContestTemplateDetailsModule } from '@/modules/fantasy/fixture/contest-template-details';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/dashboard/fantasy/fixture/contest-template-details'
)({
  component: ContestTemplateDetailsPage,
});

function ContestTemplateDetailsPage() {
  return <ContestTemplateDetailsModule />;
}
